// extracted by mini-css-extract-plugin
module.exports = {"width100":"s_dp h_dp","design3Pos":"s_qB h_dT"};